import React, { useEffect, useState, useRef } from 'react';
import "./Project.css"

import mooviapp from "../../assets/mooviapp.png"
// import sunnyside from '../../assets/sunnyside_page.png';
// import littleLemon from '../../assets/little_lemon.png';
import auto_login from "../../assets/auto_login.png"
import e_commerce from '../../assets/ua-stores.png';
import train2workinit from "../../assets/train2workinit.png"
import vgrscreen from '../../assets/vgrScreen.png'
import cholanPageIMG from "../../assets/cholanStorePage.png"
import simiesDrink from "../../assets/stybog drinks.png"
import useLocalStorage from 'use-local-storage';
import AOS from 'aos';
import Footer1 from '../footer/Footer1';
import BackToTop from '../BackToTop';
import Marque from '../Marque';
import { MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import Navbar from '../navbar/Navbar';


function Project() {
  const [isLoading, setIsLoading] = useState(true)
  const [showNextButton, setShowNextButton] = useState(true);
  const [showPreviousButton, setShowPreviousButton] = useState(false);
  const wrapperRef = useRef(null); 


    useEffect(() => {
        setTimeout(() => {

            setIsLoading(false);
        },1000);        
    },[])

    const [theme, ] = useLocalStorage('theme' ? 'dark': 'light')

  
  useEffect(() => {
    AOS.init();
  },[])

  

  const handleScroll = (direction) => {
    let scrollMovePoint = wrapperRef.current.scrollLeft;
    const max_scroll = wrapperRef.current.scrollWidth - wrapperRef.current.clientWidth;
    const scrollAmount = max_scroll * 0.1;

    if (direction === "next") {
      if (scrollMovePoint < max_scroll) {
        scrollMovePoint += scrollAmount;
      }
    } else if (direction === "previous") {
      if (scrollMovePoint > 0) {
        scrollMovePoint -= scrollAmount;
      }
    }

    wrapperRef.current.scrollTo({ left: scrollMovePoint, behavior: 'smooth' });

    setShowNextButton(scrollMovePoint < max_scroll);
    setShowPreviousButton(scrollMovePoint > 0);
  };

  return (
    <>
      {
        isLoading ? (
          <div className="load" data-theme={theme}><hr/><hr/><hr/><hr/></div>
        ) : (
          <div>
            <Navbar />
            <section id="projects" className="project_section py-20 px-0 xl:px-7 ">
              <div className='first_projects_div'>
                  <h1>Work <span>Portfolio</span></h1>
                  <p>Here are some of my recent projects that demonstrate my expertise in Web Development. Each project reflects my approach to solving real-world challenges using modern Web Dev tools and practices.</p>
              </div>
              
              <h1 className='title_txt'>E-commerce <span>Applications</span></h1>
              <div id="project__container" className='scrolling-wrapper' ref={wrapperRef}>
                {/* className="container  grid sm:grid-cols-3 sml:grid-cols- md:grid-cols-3  gap-8 px-6 sm:px-0 z-4" */}
                <div className="project_div ">         
                    <img
                      className="project__img py-4 px-3 rounded-xl"
                      src={simiesDrink}
                      alt="Stybog webapp"
                    />
                  <p className='pl-3 text-[var(--text-secondary)]'>Stybog drinks Application</p>
                  <div className='check_btn '>
                    <a href='https://github.com/uakubue/' target='blank'>
                      <button className='A'>View on Github</button>
                    </a>
                  
                    <a href='https://stybogdrinks.vercel.app/' target='blank'>
                      <button className='B'>Live Demo</button>
                    </a>
                  </div>
                </div>
                
                <div className="project_div">         
                    <img
                      className="project__img py-4 px-3 rounded-xl"
                      src={cholanPageIMG}
                      alt="Cholan Store webapp"
                    />
                  <p className='pl-3 text-[var(--text-secondary)]'>Cholan Store App</p>
                  {/* <small>Built with Redux toolkit and React useQuery library</small> */}
                  <div className='check_btn'>
                    <a href='https://github.com/uakubue/react-redux-simple-ecommerce-project' target='blank'>
                      <button className='A'>View on Github</button>
                    </a>
                  
                    <a href='https://react-redux-simple-ecommerce-project.vercel.app/' target='blank'>
                      <button className='B'>Live Demo</button>
                    </a>
                  </div>
                </div>
        
                <div className="project_div">   
                    <img
                      className="project__img py-4 px-3 rounded-xl"
                      src={e_commerce}
                      alt="E-commerce app"
                    />                  
                  <p className='pl-3 text-[var(--text-secondary)]'>Ua Store</p>
                  <div className='check_btn'>
                    <a href='https://github.com/uakubue/ua_store' target='blank'>
                      <button className='A'>View on Github</button>
                    </a>
                  
                    <a href='https://ua-store.vercel.app/' target='blank'>
                      <button className='B'>Live Demo</button>
                    </a>
                  </div>
                </div>
        
              </div>

              <h1 className='title_txt'>Other <span>Applications</span></h1>
              <div id="project__container" className='scrolling-wrapper' ref={wrapperRef}>
                {/* className="container  grid sm:grid-cols-3 sml:grid-cols- md:grid-cols-3  gap-8 px-6 sm:px-0 z-4" */}
                <div className="project_div">         
                    <img
                      className="project__img py-4 px-3 rounded-xl"
                      src={cholanPageIMG}
                      alt="Cholan Store webapp"
                    />
                  <p className='pl-3 text-[var(--text-secondary)]'>Cholan Store App</p>
                  {/* <small>Built with Redux toolkit and React useQuery library</small> */}
                  <div className='check_btn'>
                    <a href='https://github.com/uakubue/react-redux-simple-ecommerce-project' target='blank'>
                      <button className='A'>View on Github</button>
                    </a>
                  
                    <a href='https://react-redux-simple-ecommerce-project.vercel.app/' target='blank'>
                      <button className='B'>Live Demo</button>
                    </a>
                  </div>
                </div>
        
                <div className="project_div ">         
                    <img
                      className="project__img py-4 px-3 rounded-xl"
                      src={vgrscreen}
                      alt="VGR webapp"
                    />
                  <p className='pl-3 text-[var(--text-secondary)]'>VGR website</p>
                  <div className='check_btn '>
                    <a href='https://github.com/uakubue/' target='blank'>
                      <button className='A'>View on Github</button>
                    </a>
                  
                    <a href='https://vgr-site.vercel.app/' target='blank'>
                      <button className='B'>Live Demo</button>
                    </a>
                  </div>
                </div>
        
                <div className="project_div">
                    <img
                      className="project__img py-4 px-3 rounded-xl"
                      src={mooviapp}
                      alt="Moovihub app"
                    />
                  
                  <p className='pl-3 text-[var(--text-secondary)]'>Moovihub</p>
                  <div className='check_btn'>
                    <a href='https://github.com/uakubue?tab=repositories' target='blank'>
                      <button className='A'>View on Github</button>
                    </a>
                  
                    <a href='https://moovihub.vercel.app/' target='blank'>
                      <button className='B'>Live Demo</button>
                    </a>
                  </div>
                </div>
        
                <div className="project_div">
                    <img
                      className="project__img py-4 px-3 rounded-xl"
                      src={train2workinit}
                      alt="Train2workinit Academy"
                    />
                  <p className='pl-3 text-[var(--text-secondary)]'>Train2workinit Academy</p>
                  <div className='check_btn'>
                    <a href='https://github.com/uakubue' target='blank'>
                      <button className='A'>View on Github</button>
                    </a>
                  
                    <a href='https://train2workinit.com/' target='blank'>
                      <button className='B'>Live Demo</button>
                    </a>
                  </div>
                </div>
        
                <div className="project_div">
                
                    <img
                      className="project__img py-4 px-3 rounded-xl"
                      src={e_commerce}
                      alt="E-commerce app"
                    />
                  
                  <p className='pl-3 text-[var(--text-secondary)]'>Ua Store</p>
                  <div className='check_btn'>
                    <a href='https://github.com/uakubue/ua_store' target='blank'>
                      <button className='A'>View on Github</button>
                    </a>
                  
                    <a href='https://ua-store.vercel.app/' target='blank'>
                      <button className='B'>Live Demo</button>
                    </a>
                  </div>
                </div>
                
                <div className="project_div">
                    <img
                      className="project__img py-4 px-3 rounded-xl"
                      src={auto_login}
                      alt="Day and night login"
                    />
                  <p className='pl-3 text-[var(--text-secondary)]'>Day_Night_login theme</p>
                  <div className='check_btn'>
                    <a href='https://github.com/uakubue?tab=repositories' target='blank'>
                      <button className='A'>View on Github</button>
                    </a>
                  
                    <a href='https://auto-theme-login.vercel.app/' target='blank'>
                      <button className='B'>Live Demo</button>
                    </a>
                  </div>
                </div>
                
              </div>
              {showPreviousButton && (
                <button className="arrow previous" onClick={() => handleScroll("previous")}>
                  <MdOutlineKeyboardDoubleArrowLeft style={{fontSize: "3em"}}/>
                </button>
              )}
              {showNextButton && (
                <button className="arrow next" onClick={() => handleScroll("next")}>
                  <MdOutlineKeyboardDoubleArrowRight style={{fontSize: "3em"}} />
                </button>
              )}
            </section>
            <Marque />
            <Footer1 />
            <BackToTop />
          </div>
        )
      }
    </>
  );
}

export default Project